import React, { useEffect, useRef, useState } from 'react'
import { useParams } from 'react-router-dom';
import { Button, Container } from '@mui/material';
import * as XLSX from 'xlsx';

import { IMaterialPrice, IMaterialPriceLight, IMaterialPriceUpdate } from '../../../types/material';

import { useUserContext } from '../../../contexts/userContext';

import { VendorService } from '../../../services/vendorService';
import { MaterialPriceService } from '../../../services/materialPriceService';

import PermissionGate from '../../permissionGate';
import Navigation from "../../header";
import VendorMaterialPricingTable from '../../tables/vendorMaterialPricingTable';
import Json from '../../json';

interface ExcelData {
	[key: string]: any;
}

const VendorPricing: React.FunctionComponent = ({ }) => {
	let { id } = useParams();
	const userContext = useUserContext();
	const [data, setData] = useState<IMaterialPriceLight[]>([]);
	const fileInputRef = useRef<HTMLInputElement>(null);
	const [title, setTitle] = useState("Upload Material Pricing");

	const getVendor = async () => {
		if (id) {
			VendorService.getVendor(id)
				.then((response) => {
					console.log('VendorService.getVendor: SUCCESS', response);
					setTitle("Upload Material Pricing for " + response.data.details?.name);
				})
				.catch((error) => {
					console.log('VendorService.getVendor: ERROR', error);
				});
		}
	}

	useEffect(() => {
		getVendor();
	}, [id])

	const callbackUnloadData = () => {
		setData(new Array<IMaterialPriceLight>);
		fileInputRef.current!.value = "";
	}

	const handleFileUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
		const file = e.target.files?.[0];
		const vendorId = id ? Number.parseInt(id) : undefined;

		if (vendorId && file) {
			const reader = new FileReader();
			reader.onload = (e) => {
				const data = new Uint8Array(e.target?.result as ArrayBuffer);
				const workbook = XLSX.read(data, { type: 'array' });
				const sheetName = workbook.SheetNames[0];
				const worksheet = workbook.Sheets[sheetName];
				const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
				setData(MaterialPriceService.mapMaterialPricesFromVendorUpload(vendorId, jsonData.slice(1)));
			};
			reader.readAsArrayBuffer(file);
		}
	};

	return (
		<div className="hwi-vendor-pricing">
			<Navigation></Navigation>
			<Container maxWidth="lg" className="route-container">
				<PermissionGate permission={userContext.permissions?.canManageVendors}>
					<section className="management-page-header">
						<div className="title">{title}</div>
					</section>
					<section>
						<input
							type="file"
							ref={fileInputRef}
							accept=".xlsx, .xls"
							onChange={handleFileUpload}
							style={{ display: 'none' }}
						/>
						{id && data.length > 0 ? (
							<VendorMaterialPricingTable id={id} data={data} validate={true} unloadData={callbackUnloadData}></VendorMaterialPricingTable>
						) : (
							<Button variant="contained" onClick={() => fileInputRef.current?.click()}>Choose File</Button>
						)}
					</section>
					{/* <Json data={fileInputRef}></Json> */}
				</PermissionGate>
			</Container>
		</div>
	);
}

export default VendorPricing;